import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TShopGoodsResponsePayload,
	TShopResponsePayload,
	TShopStore,
	TShopAttributesFormPayload,
	TShopAddResponsePayload,
	TShopAttributesResponsePayload,
	TShopMigrateResponsePayload,
	TShopRestartMigrationResponsePayload,
} from './types';

// ==========================================:
const getShopsState = (state: TStoreState): TShopStore => state.shops;
export const getShops = createSelector([getShopsState], (shops: TShopStore) => shops);

// ====================================================:
export const getShopsList = createSelector(
	[getShops],
	(shops: TShopStore): TShopResponsePayload => shops.shops,
);

// ====================================================:

export const getShopsListIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopsLoading,
);

// ====================================================:

export const getShopGoodsList = createSelector(
	[getShops],
	(shops: TShopStore): TShopGoodsResponsePayload => shops.shopGoods,
);

// ====================================================:

export const getShopGoodsListIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopGoodsLoading,
);

// ====================================================:

export const getShopAddIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopAddLoading,
);

// ====================================================:

export const getShopAddError = createSelector(
	[getShops],
	(shops: TShopStore): string | null => shops.shopAddError,
);

// ====================================================:

export const getNewShopId = createSelector(
	[getShops],
	(shops: TShopStore): TShopAddResponsePayload => shops.newShopId,
);

// ====================================================:

export const getShopDeleteIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopDeleteLoading,
);

// ====================================================:

export const getShopAttributesForm = createSelector(
	[getShops],
	(shops: TShopStore): TShopAttributesFormPayload => shops.shopAttributesForm,
);

// ====================================================:

export const getShopAttributesFormIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopAttributesFormLoading,
);

// ====================================================:

export const getShopAttributes = createSelector(
	[getShops],
	(shops: TShopStore): TShopAttributesResponsePayload => shops.shopAttributes,
);

// ====================================================:

export const getShopAttributesIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopAttributesLoading,
);

// ====================================================:

export const getShopMigrate = createSelector(
	[getShops],
	(shops: TShopStore): TShopMigrateResponsePayload => shops.shopMigrate,
);

// ====================================================:

export const getShopMigrateIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopMigrateLoading,
);

// ====================================================:

export const getShopMigrationStatus = (shopId: number) =>
	createSelector(
		[getShops],
		(shops: TShopStore): number | null => shops.shopMigrationStatus[shopId] ?? null,
	);

// ====================================================:

export const getShopMigrationStatusIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopMigrationStatusLoading,
);

// ====================================================:

export const getShopRestartMigration = createSelector(
	[getShops],
	(shops: TShopStore): TShopRestartMigrationResponsePayload => shops.shopRestartMigration,
);

// ====================================================:

export const getShopRestartMigrationIsLoad = createSelector(
	[getShops],
	(shops: TShopStore): boolean => shops.shopRestartMigrationLoading,
);
